import React from 'react';

const Close = (props) => (
  <svg viewBox="0 0 8 8" {...props}>
    <path d="M4 2.586L6.121.464 7.536 1.88 5.414 4l2.122 2.121L6.12 7.536 4 5.414 1.879 7.536.464 6.12 2.586 4 .464 1.879 1.88.464 4 2.586z" />
  </svg>
);

export default Close;
